export function propertyStatusHandler(status) {
  if (status === "OFF_PLAN") {
    return "Sold";
  }
  if (status === "SALE") {
    return "Sold";
  }
  if (status === "RENT") {
    return "Rented";
  }
}

export const salesHandler = (property_purpose, completion_status) => {
  if (
    property_purpose === "Sale" &&
    (completion_status === "completed_primary" ||
      completion_status === "completed")
  ) {
    return "SALE";
  } else if (property_purpose === "Sale") {
    return "SALE_OFF_PLAN";
  } else {
    return property_purpose?.toUpperCase();
  }
};

export const transformValueSwitch = (value) => {
  switch (value) {
    case "OFF_PLAN":
      return "offplan";
    case "RENT":
      return "rent";
    case "SALE_OFF_PLAN":
      return "saleoffplan";
    case "SALE":
      return "sale";
    default:
      return value.toLowerCase();
  }
};
